/*
 * @Author: Jack jack-lo@foxmail.com
 * @Date: 2023-10-16 18:08:58
 * @LastEditors: Jack jack-lo@foxmail.com
 * @LastEditTime: 2023-10-16 21:25:48
 */
let loading = false;
const qs = [];

window.BMapLoaderCallback = () => {
  loading = false;
  const bm = window.BMapGL;
  while (qs.length) {
    const cb = qs.shift();
    cb(bm);
  }
};

function load(data = {}) {
  if (window.BMapGL) {
    return Promise.resolve(window.BMapGL);
  }
  if (loading) {
    return new Promise((res) => {
      qs.push(res);
    });
  }
  const { version, type, ak } = data;
  const script = document.createElement('script');
  const query = `?v=${version || '1.0'}&type=${type || 'webgl'}&ak=${ak || ''}&callback=BMapLoaderCallback`;
  script.src = `https://api.map.baidu.com/api${query}`;
  const body = document.getElementsByTagName('body')[0];
  body.appendChild(script, script);
  loading = true;
  return new Promise((res) => {
    qs.push(res);
  });
}

export default { load };
